export default {
  meta: {
    title: '商机趋势'
  }
};
